<template>
  <div class="chart">
     <div class="sub">{{dataSource.rate}} %</div>
     <div class="money">{{dataSource.real}} W</div>
     <div class="title">实际{{title}}</div>
     <div class="plan">计划{{title}}{{dataSource.plan}}</div>
    <IEcharts :option="gauge"></IEcharts>
  </div>
</template>
<script>
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'

var axislineColor = {
  x: 0,
  y: 0,
  x2: 1,
  y2: 0,
  type: "linear",
  global: false,
  colorStops: [
    {
      offset: 0,
      color: "#86E687"
    },
    {
      offset: 1,
      color: "#86E687"
    }
  ]
}
export default {
  name: 'chart-gauge',
  components: {
    IEcharts
  },
  props: {
      dataSource:{
          type:Object,
          default:()=>{
              return {}
          }
      },
      title:{
          type:String,
          default:()=>{
              return ''
          }
      }
  },
  watch: {
    
    dataSource(newVal, val) {
      console.log('newVal',newVal)
      this.initView()
    },
  },
  mounted () {
      this.initView()
  },
  data() {
    return {
      gauge: {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%"
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {}
          }
        },
        series: [
          {
            min: 0,
            max: 220,
            startAngle: 220,
            endAngle: -40,
            type: 'gauge',
            radius:'80%',
            axisLabel: {
              show: false
            },
            detail: {
              show: false,
              
              color: '#00C6D5',
              fontSize: 50,
              offsetCenter: [-20, -30]
            },

            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [1 / 210, axislineColor],
                  [1, '#DCDCDC']
                ]
              }
            },
            pointer: {
              show: false,
            },
            itemStyle: {
              color: '#DCDCDC'
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: [{
              value: 1
            }]
          }]
      },
    }
  },
  methods: {
      initView () {
          let value = this.dataSource.rate
          console.log('val',value)
          this.gauge.series[0].axisLine.lineStyle.color[0] = [value / 100, axislineColor]
          this.gauge.series[0].data[0]['value'] = value
      }
  }
}
</script>
<style scoped>
.chart {
  position: relative;
  width: 140px;
  height: 120px;
  /* border: 1px solid red; */
}
.sub {
    position: absolute;
    left: 36px;
    bottom: 68px;
    width:70px;
    text-align: center;
    font-size: 12px;
    color: #999999;
}
.money {
    position: absolute;
    left: 34px;
    bottom: 48px;
    width:70px;
    text-align: center;
    font-size: 13px;
    color: #333;
}
.title {
    position: absolute;
    left: 34px;
    bottom: 20px;
    width:70px;
    text-align: center;
    font-size: 13px;
    color: #333;
}
.plan {
    position: absolute;
    left: 20px;
    bottom: 0;
    width:100px;
    text-align: center;
    font-size: 12px;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/components/gauge.vue